import * as React from 'react';
import { Tag } from '@revfluence/fresh';
import { TriangleExclamationIcon } from '@revfluence/fresh-icons/regular/esm';

export const ErrorTag = () => (
  <Tag color="error" icon={<TriangleExclamationIcon />}>Disconnected</Tag>
);
